import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useMultiSite } from './useMultiSite';

/**
 * A convenience hook for programmatic navigation uses history's `push` or `replace`. The proper locale
 * is automatically prepended to the provided path. Additional args are passed through to `history`.
 * @returns {function} - Returns a navigate function that passes args to history methods.
 */
const useNavigation = <T = object>(): ((
    path: string,
    action?: 'push' | 'replace',
    state?: T,
) => void) => {
    const history = useHistory<T>();

    const { site, locale: localeShortCode, buildUrl } = useMultiSite();

    return useCallback(
        (path, action = 'push', state?: T) => {
            const updatedHref = buildUrl(path);
            history[action](path === '/' ? '/' : updatedHref, state);
        },
        [localeShortCode, site],
    );
};

export { useNavigation };
